import { AsyncPipe, CommonModule, DatePipe, DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';

// NG-Boorstrap
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeaderDirective, SortEvent } from './sortable.directive';

// Models
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoadingComponent } from '../../spinner/loading/loading.component';
import { IPagination } from '../pagination/IPagination.model';
import { PaginationComponent } from '../pagination/pagination.component';
import { Ipaginated } from './Ipaginated.model';
import { NSTableColumn } from './table-column.model';
import { FormatterPipe } from '../pipes/formatter.pipe';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    CommonModule,
    NgFor,
    DecimalPipe,
    DatePipe,
    FormsModule,
    AsyncPipe,
    NgbTypeaheadModule,
    NgbdSortableHeaderDirective,
    NgIf,
    FormatterPipe,
    FontAwesomeModule,
    LoadingComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    NgbTooltipModule,
    PaginationComponent,
  ],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  providers: [
    DecimalPipe,
    DatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableComponent),
      multi: true,
    },
  ],
})
export class TableComponent implements ControlValueAccessor {
  @Input() isLoading$!: Observable<boolean>;

  @Input() tableHead: NSTableColumn[] = [];
  @Input() actionsButton: any[] = [];
  @Input() maxInlineAction = 4;
  @Input() enableCheckbox = false;
  @Input() paginatedData$: Observable<Ipaginated<any>>;

  @Output() onSortEvent = new EventEmitter<SortEvent>();
  @Output() onChangeEvent = new EventEmitter<IPagination>();
  @Output() onDeleteEvent = new EventEmitter<any>();
  @Output() onUpdateEvent = new EventEmitter<any>();
  @Output() onOpenModalEvent = new EventEmitter<any>();
  @ViewChildren(NgbdSortableHeaderDirective) headers!: QueryList<NgbdSortableHeaderDirective>;
  sortBy: string;
  search: string | undefined;
  selectedItems: any[] = [];

  onChange: any = () => {};
  onTouch: any = () => {};

  set value(val: any[]) {
    this.selectedItems = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: any) {
    this.value = value;
  }
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortBy = `${column}:${direction}`;
    this.onSortEvent.emit({ column, direction });
  }

  onPageChange(pagination: IPagination) {
    this.onChangeEvent.emit({
      sortBy: this.sortBy,
      ...pagination,
    });
  }

  onDelete(item: any) {
    this.onDeleteEvent.emit(item);
  }

  onUpdate(item: any) {
    this.onUpdateEvent.emit(item);
  }

  eventAction(elem: { action: any; item: any }) {
    elem.action.eventAction(elem.item);
  }
  getCheckedItems(items: any[]) {
    return items.every((i) => this.isSelected(i));
  }
  getIndeterminateItems(items: any[]) {
    return items.some((i) => this.isSelected(i)) && !this.getCheckedItems(items);
  }

  toggleAllItems(items: any[]) {
    if (this.getCheckedItems(items)) {
      this.selectedItems = [];
    } else {
      items.forEach((i) => (!this.isSelected(i) ? this.toggleItem(i) : null));
    }
  }
  isSelected(item: any) {
    return this.selectedItems.find((i) => (i.id && i.id === item.id) || (i.identifier && i.identifier === item.identifier));
  }

  toggleItem(item: any) {
    if (this.isSelected(item)) {
      this.selectedItems = [...this.selectedItems.filter((i) => i.id !== item.id || i.identifier !== item.identifier)];
    } else {
      this.selectedItems.push(item);
    }
    this.writeValue(this.selectedItems);
  }

  onOpenModal(selectedItems: any) {
    this.onOpenModalEvent.emit(selectedItems);
  }

  getAccordionMessage(elem: any) {
    this.actionsButton?.find((action: any) => action.action === 'accordion')?.eventAction(elem);
  }
}
